import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import FontFaceObserver from 'fontfaceobserver';

const boucherie = new FontFaceObserver('Boucherie Block');
boucherie.load().then(() => {
  document.documentElement.classList.add('font-loaded');
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
<meta name="viewport" content="width=device-width, initial-scale=1.0"></meta>

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
